import { LucideIcon, Users, Database, Target, Sparkles } from 'lucide-react'

export interface Pillar {
    id: string
    title: string
    description: string
    icon: LucideIcon
}

export const pillars: Pillar[] = [
    {
        id: 'cultura-agil',
        title: 'Cultura Ágil',
        description: 'Desenvolvimento de times e cultura digital.',
        icon: Users,
    },
    {
        id: 'arquitetura-corporativa',
        title: 'Arquitetura Corporativa',
        description: 'Estruturas de tecnologia com visão de negócio.',
        icon: Database,
    },
    {
        id: 'ti-estrategica',
        title: 'TI Estratégica',
        description: 'Soluções personalizadas com foco em resultado.',
        icon: Target,
    },
    {
        id: 'experiencia',
        title: 'Experiência',
        description: 'Valor agregado ao público final.',
        icon: Sparkles,
    },
]

